import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 25456 22561"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:368.925;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528316193056">
        <path
          d="M1250 679h22978M1134 711c0 243-213 439-475 439S184 954 184 711c0-242 213-438 475-438s475 196 475 438z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 368.925,
            strokeLinejoin: "round",
          }}
        />
        <ellipse
          cx={24749}
          cy={679}
          className="fill-none stroke1"
          style={{
            strokeWidth: 368.925,
            strokeLinejoin: "round",
          }}
          rx={522}
          ry={494}
        />
        <path
          d="M19840 12276c-2442-1761-5902-5167-5693-11486M23325 22323l-7-21546M23325 22377c-580 0-580-108-1161-108-580 0-580 108-1159 108-581 0-581-108-1162-108-583 0-583 108-1165 108-581 0-1164-54-1164-54l1978-8645M19751 19794l223-1723M19443 22167l206-1589M21586 22323l-212-4016"
          className="fill-none stroke1"
          style={{
            strokeWidth: 368.925,
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M19126 12276h4199v1239h-4199zM21529 9372s-176 1669 933 2808M20337 10420s33 836 628 1733M5660 12276c2442-1761 5902-5167 5693-11486M2175 22323V777M2175 22377c581 0 581-108 1161-108s580 108 1160 108c581 0 581-108 1162-108 582 0 582 108 1164 108s1164-54 1164-54l-1977-8645M5749 19794l-223-1723M6060 22188l-206-1589M3914 22323l212-4016M2175 12276h4199v1239H2175zM3971 9372s176 1669-933 2808M5163 10420s-33 836-628 1733"
          className="fill-none stroke1"
          style={{
            strokeWidth: 368.925,
            strokeLinejoin: "round",
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
